let sectionURL;
const productHandle = document.querySelector('mm-card')?.dataset.handle;
// Not sure why this was added but it's always failing with 404.
// fetch(`/products/gs-69`).then(res => res.text()).then(resText => {
//     const domParser = new DOMParser().parseFromString(resText, 'text/html')
//     sectionURL = domParser.querySelector('product-info').dataset.section
// })
class UpdatedCard extends HTMLElement{
    constructor(){
            super();
            this.form = this.querySelector('form');
            this.formIdInput = this.form?.querySelector('[name="id"]');
            this.optionsContainer = this.querySelectorAll('.button--varaints__wrapper');
            this.optionsContainer.forEach(container => container.querySelectorAll('#variant--selector').forEach(option => option.addEventListener('click', this.onOptionChange.bind(this, option))));
            this.productHandle = this.dataset.handle;
    }
    onOptionChange(option,event){
        event.preventDefault();
        const parentContainer  = option.closest('.button--varaints__wrapper');
        const swatchParentContainer = option.closest('.product-form__input--swatch');
        parentContainer.querySelectorAll('#variant--selector').forEach(option => option.removeAttribute('checked'));
        option.setAttribute('checked', '');
        swatchParentContainer ? swatchParentContainer.querySelector('[data-selected-swatch-value="Color"]').innerHTML = option.getAttribute('name') : null;
        let selectedValue = option.value;
        if(this.optionsContainer.length > 1){
            selectedValue = this.getSelectedOptionValues();
        }
        this.getPage(selectedValue);
    }
    updateCardLinks(value){
        const buttonLinks = [
            this.querySelector('.image--linkage'),
            this.querySelector('.title-price-wrapper .full-unstyled-link'),
            this.querySelector('.learn_more--button a')
          ];
          buttonLinks.forEach(item => {
            if (item) {
              item.href = `/products/${this.productHandle}?variant=${value}`;
            }
          });
    }
    getPage(values){
        fetch(this.getRequestURL(values)).then(response => response.text())
        .then(responseText => {
            const domParser = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateContent(domParser);
        })
    }
    updateContent(html, swatchParentContainer){
        const selectedVariant = this.getSelectedVariant(html);
        this.formIdInput.value = selectedVariant.id;
        this.updateCardLinks(selectedVariant.id)
        if(selectedVariant.featured_image){
            this.updateMedia(html.querySelector('.product .product__media'))
        }
        this.updatePrice(html.querySelector('.price'));
    }
    updatePrice(priceHtml){
        const priceContainers = ['.price__sale .price-item--last', '.price__regular .price-item--regular'];
        const btnPrice = this.querySelector('.btn--price');
        priceContainers.forEach(priceBox => {
            if(this.querySelector(priceBox)){
                this.querySelector(priceBox).innerHTML = priceHtml.querySelector(priceBox)?.innerHTML
            }
        })
        if(btnPrice){
            btnPrice.innerHTML = priceHtml.querySelector('.price__sale .price-item--last')?.innerHTML;
        }
    }
    getSelectedVariant(html){
        const selectedVariant = html.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }
    updateMedia(media){
        const mediaBox = this.querySelector('.card__media .media');
        mediaBox.innerHTML = media.innerHTML;
    }
    getSelectedOptionValues() {
        return Array.from(this.optionsContainer).flatMap(container => {
            const buttons = container.querySelectorAll('button[checked]');
            return Array.from(buttons).map(button => button.value);
        });
    }
    getRequestURL(values){
        const selectedOptionValue = typeof values == Array ? values.join(',') : values;
        return `/products/${this.productHandle}?option_values=${selectedOptionValue}&section_id=${sectionURL}`
    }
}
if(!customElements.get('mm-card')){
    customElements.define('mm-card', UpdatedCard);
}

// For Collapsible Section
const collapsibleBoxes = document.querySelectorAll('.collapsible-content');
!!collapsibleBoxes && updateCollapsible();
function updateCollapsible(){
    collapsibleBoxes.forEach(parent => {
        const accordions = parent.querySelectorAll('.accordion');
        accordions.forEach(accordion => accordion.addEventListener('click', () => {
            accordions.forEach(accordion => hideAccordion(accordion));
        }))
    })
}
function hideAccordion(accordion){
    accordion.querySelector('details').removeAttribute('open');
    accordion.querySelector('summary').setAttribute('aria-expanded', 'false')
}